<template>
  <div class="challenge"></div>
</template>

<script>
export default {
  name: "ChallengeView",

  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>